var map = {
	"./03-dora&phil.jpg": "5d24",
	"./04-dora&phil.jpg": "0e09",
	"./07-dora&phil.jpg": "4f81",
	"./coronaTransport.mp4": "1680",
	"./dyp01.jpg": "859e",
	"./dyp03.jpg": "2c6b",
	"./dyp09.jpg": "6f52",
	"./dyp10.jpg": "d09a",
	"./dyp12.jpg": "bd58",
	"./dyp13.jpg": "474a",
	"./dyp16.jpg": "9a12",
	"./illusCorona.jpg": "25d6",
	"./illusCorona2.jpg": "dfb5",
	"./illusCorona3.jpg": "72cd",
	"./illusCorona4.jpg": "ca89",
	"./illusCorona5.jpg": "68f0",
	"./illusThrones.jpg": "e20b",
	"./illusThrones2.jpg": "2f53",
	"./illusThrones3.jpg": "00bd",
	"./illusThrones4.jpg": "425f",
	"./illusThrones5.jpg": "ec7e",
	"./illusThrones6.jpg": "5ecc",
	"./ilusTunelera.jpg": "f9c4",
	"./infoMineria.jpg": "5c69",
	"./infoPetroleo.jpg": "3f81",
	"./infoRepresa.jpg": "9b55",
	"./infoTunelera.jpg": "f38a",
	"./infoVino.jpg": "c989",
	"./mineria3d.jpg": "7799",
	"./miset2.jpg": "10a0",
	"./miset2a.jpg": "0459",
	"./miset3.jpg": "5ff8",
	"./miset3a.jpg": "b4b1",
	"./miset4.jpg": "e8dc",
	"./miset4a.jpg": "eb04",
	"./misetIllus.mp4": "be34",
	"./petroleo3d.jpg": "1ba5",
	"./placeholder.png": "6695",
	"./represa3d.jpg": "60d8",
	"./tunelera3d.jpg": "7f18",
	"./vino3d.jpg": "ff97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9631";